import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	makeStyles,
	Typography,
	Divider,
} from "@material-ui/core";
import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
const useStyles = makeStyles(() => ({
	drawingsButton: {
		backgroundColor: "rgba(147, 112, 219, 0.1)",
		"&:hover": {
			backgroundColor: "rgba(147, 112, 219, 0.2)",
		},
	},
	attachmentsButton: {
		backgroundColor: "rgba(255, 165, 0, 0.1)",
		"&:hover": {
			backgroundColor: "rgba(255, 165, 0, 0.4)",
		},
	},
	lotoButton: {
		backgroundColor: "rgba(50, 205, 50, 0.1)",
		"&:hover": {
			backgroundColor: "rgba(50, 205, 50, 0.2)",
		},
	},
	partsButton: {
		backgroundColor: "rgba(70, 130, 180, 0.1)",
		"&:hover": {
			backgroundColor: "rgba(70, 130, 180, 0.2)",
		},
	},
	dialogActions: {
		padding: 20,
		justifyContent: "center",
	},
}));

interface Props {
	open: boolean;
	onClose: () => void;
	onOpenAssetPartsPicker: () => void;
	onOpenAssetLOTOPicker: () => void;
	onOpenAssetAttachmentsPicker: () => void;
	onOpenAssetDrawingsPicker: () => void;
}

export const ImportAssetResourcesDialog = ({
	open,
	onClose,
	onOpenAssetPartsPicker,
	onOpenAssetLOTOPicker,
	onOpenAssetAttachmentsPicker,
	onOpenAssetDrawingsPicker,
}: Props) => {
	const classes = useStyles();

	const {
		state: { assetDrawings, assetAttachments, assetParts, assetLOTO },
	} = useTemplatesContext();

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle style={{ paddingBottom: 5 }}>
				<Typography variant="h5">Import Asset Resources</Typography>
			</DialogTitle>
			<Divider />

			<DialogContent>
				<Typography style={{ paddingBottom: 5 }}>
					The asset to which this Template is assigned has resources available.{" "}
					<br />
					You can review and assign them to the Template:
				</Typography>
				<Grid container spacing={2} style={{ padding: "10px 0" }}>
					<Grid item xs={12} sm={6}>
						<Button
							variant="contained"
							fullWidth
							className={` ${classes.drawingsButton}`}
							onClick={onOpenAssetDrawingsPicker}
							disabled={assetDrawings.length === 0}
						>
							Import Drawings ({assetDrawings.length})
						</Button>
					</Grid>
					<Grid item xs={12} sm={6}>
						<Button
							variant="contained"
							fullWidth
							className={` ${classes.attachmentsButton}`}
							onClick={onOpenAssetAttachmentsPicker}
							disabled={assetAttachments.length === 0}
						>
							Import Attachments ({assetAttachments.length})
						</Button>
					</Grid>
					<Grid item xs={12} sm={6}>
						<Button
							variant="contained"
							fullWidth
							className={` ${classes.lotoButton}`}
							onClick={onOpenAssetLOTOPicker}
							disabled={assetLOTO.length === 0}
						>
							Import LOTO ({assetLOTO.length})
						</Button>
					</Grid>
					<Grid item xs={12} sm={6}>
						<Button
							variant="contained"
							fullWidth
							className={` ${classes.partsButton}`}
							onClick={onOpenAssetPartsPicker}
							disabled={assetParts.length === 0}
						>
							Import Parts ({assetParts.length})
						</Button>
					</Grid>
				</Grid>
			</DialogContent>
			<Divider />
			<DialogActions className={classes.dialogActions}>
				<Grid container>
					<Grid item md={12} xs={12}>
						<Button
							fullWidth
							variant="contained"
							color="default"
							onClick={onClose}
						>
							Close
						</Button>
					</Grid>
				</Grid>
			</DialogActions>
		</Dialog>
	);
};
